<template>
	<div style="width: 100%; height: 100%;">
		<div style="padding: 6px;font-size: 16px;" v-if="selectdItem.compontChildren[0].data.code == '' && type == 'design'">
			请添加内容
		</div>


		

	<!-- 	<div>
			<iframe v-if="selectdItem.compontChildren[0].data.code != '' && type == 'design'"
				style="border: solid 0px #fff;" width="100%" @load="onIframeLoad"
				scrolling="no" seamless allowfullscreen class="preview-frame"
				:srcdoc="selectdItem.compontChildren[0].data.code" ref="iframe"></iframe>
		</div> -->
			
		<iframe v-if="selectdItem.compontChildren[0].data.code != ''"
			style="border: solid 0px #fff;" width="100%" @load="onIframeLoad"
			scrolling="no" seamless allowfullscreen class="preview-frame"
			:srcdoc="selectdItem.compontChildren[0].data.code" ref="iframe"></iframe>
	</div>
</template>

<script>
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				resizeObserver: null,
				debounceTimer: null
			}
		},
		methods: {
			onIframeLoad() {
				console.log('this.$refs.iframe', )
				const iframe = this.$refs.iframe;
				const height = iframe.contentWindow.document.body.scrollHeight;
				const width = iframe.contentWindow.document.body.scrollWidth;
				iframe.style.height = height + 'px';
				// iframe.style.maxWidth = '100%'
				// iframe.style.width = width + 'px';
				console.log('height', height)
				console.log('width', width)
			},
		},

	}
</script>

<style>
</style>